module.exports = __webpack_public_path__ + "static/media/ic-grt-logo.bc5ffc3f.png";